import { dayList } from "./common";

export function getScheduleOptionText(dayIndex, timeStart, timeEnd) {
  const dayName = dayList[dayIndex];
  const start = timeStart.substr(0, 5).replace(":", ".");
  const end = timeEnd.substr(0, 5).replace(":", ".");
  return `${dayName}, ${start} - ${end} WIB`;
}

export function getCheckupStatus(checkup) {
  if (checkup.deleted_at) {
    return "canceled";
  }
  if (checkup.scheduled_at && !checkup.suggestion) {
    return "scheduled";
  }
  if (checkup.scheduled_at && checkup.suggestion) {
    return "completed";
  }
  return "unscheduled";
}

export function getCheckupStatusIndo(status) {
  if (status == "canceled") return "Dibatalkan";
  if (status == "scheduled") return "Terjadwal";
  if (status == "completed") return "Selesai";
  return "Menunggu";
}

export function getCheckupBadge(status) {
  if (status == "canceled") return "badge-danger";
  if (status == "scheduled") return "badge-primary";
  if (status == "completed") return "badge-success";
  return "";
}

export function getWhatsappMessageTemplate(lang = "id") {
  let template =
    "{greeting} {name}\n\nKami dari tim Layanan Konsultasi Psikologi - Health Promoting University Fakultas Teknik (HPU FT). Terima kasih sudah berpartisipasi dalam program *Satu Teknik Corner*.\n\nBerikut adalah jadwal konsultasi Anda pada hari *{date} pukul {time}* berlokasi di {room}.\n\nDemikian informasi yang kami sampaikan mohon untuk hadir tepat waktu. Mohon mengirimkan konfirmasi kehadiran dengan membalas pesan ini. Atas perhatian dan kerjasamanya kami ucapkan terima kasih.";

  if (lang === "en") {
    template =
      "{greeting} {name}\n\nWe are from the team of Psychology Consultation Service - Health Promoting University Faculty of Engineering (HPU FT). Thank you for participating in the *Satu Teknik Corner* program.\n\nHere is your consultation schedule on *{date} at {time}* located in *{room}*.\n\nThus the information we convey, please be on time. Please send confirmation of attendance by replying to this message. Thank you for your attention and cooperation.";
  }
  return template;
}
